import { create } from "zustand";

export const defaultStartingPrice = 0;
export const defaultEndingPrice = 5000;

export const defaultStartSlice = 0;
export const defaultEndSlice = 12;

const filterStore = create((set) => ({
  mainProduct: [],
  filterProduct: [],

  gender: null,
  categoryID: null,

  resetPrice: false,
  resetColor: false,
  resetSize: false,
  resetAll: false,

  whatsNew: false,

  priceValue: [defaultStartingPrice, defaultEndingPrice],
  priceRadio: "",
  selectedColors: [],
  selectedSizes: [],

  selectSort: "What's New",
  pageCount: 0,
  page: 1,

  startSlice: defaultStartSlice,
  endSlice: defaultEndSlice,

  // searching
  searchID: null,
  resetGender: false,
  searchGender: "",
  // searching

  setGender: ({ value }) => {
    set({ gender: value });
  },

  setCategoryID: ({ value }) => {
    set({ categoryID: value });
  },

  setFilterProduct: ({ data }) => {
    set({ filterProduct: data });
  },

  setMainProduct: ({ data }) => {
    set({ mainProduct: data });
  },

  setResetPrice: ({ value }) => {
    set({ resetPrice: value });
  },

  setResetColor: ({ value }) => {
    set({ resetColor: value });
  },

  setResetSize: ({ value }) => {
    set({ resetSize: value });
  },

  setResetAll: ({ value }) => {
    set({ resetAll: value });
  },

  setPriceValue: ({ value }) => {
    set({ priceValue: value });
  },

  setPriceRadio: ({ value }) => {
    set({ priceRadio: value });
  },

  setSelectedColors: ({ value }) => {
    set({ selectedColors: value });
  },

  setSelectedSizes: ({ value }) => {
    set({ selectedSizes: value });
  },

  setSelectSort: ({ value }) => {
    set({ selectSort: value });
  },

  setPageCount: ({ value }) => {
    set({ pageCount: value });
  },

  setPage: ({ value }) => {
    set({ page: value });
  },

  setStartSlice: ({ value }) => {
    set({ startSlice: value });
  },

  setEndSlice: ({ value }) => {
    set({ endSlice: value });
  },

  setSearchID: ({ value }) => {
    set({ searchID: value });
  },

  setResetGender: ({ value }) => {
    set({ resetGender: value });
  },

  setSearchGender: ({ value }) => {
    set({ searchGender: value });
  },

  setWhatsNew: ({ value }) => {
    set({ whatsNew: value });
  },

  resetFilters: () => {
    set({
      mainProduct: [],
      filterProduct: [],

      gender: null,
      categoryID: null,

      resetPrice: false,
      resetColor: false,
      resetSize: false,
      resetAll: false,

      whatsNew: false,

      priceValue: [defaultStartingPrice, defaultEndingPrice],
      priceRadio: "",
      selectedColors: [],
      selectedSizes: [],

      selectSort: "What's New",
      pageCount: 0,
      page: 1,

      startSlice: defaultStartSlice,
      endSlice: defaultEndSlice,

      // searching
      searchID: null,
      resetGender: false,
      searchGender: "",
      // searching
    });
  },
}));

export default filterStore;
